import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LOGOUT_REQUEST, LOGOUT_SUCCESS } from "../../Utils/Constant";
import { FiLogOut } from "react-icons/fi";
import ConfirmationATM from "../../Common/ConfirmationATM";

const LogoutButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLogout = () => {
    dispatch({ type: LOGOUT_REQUEST }); 
    setShowConfirm(false);
    navigate("/");
  };
  
  return (
    <>
      <button
        onClick={() => setShowConfirm(true)}
        className="d-flex align-items-center justify-content-center gap-2 w-100"
        style={{
          backgroundColor: "#dc3545",
          color: "#fff",
          border: "none",
          borderRadius: "0.5rem",
          padding: "0.6rem 1rem",
          fontSize: "1rem",
          fontWeight: "600",
          boxShadow: "0 4px 12px rgba(220, 53, 69, 0.3)",
          transition: "background-color 0.3s ease, box-shadow 0.3s ease",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#c82333";
          e.currentTarget.style.boxShadow = "0 6px 18px rgba(200, 35, 51, 0.4)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#dc3545";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(220, 53, 69, 0.3)";
        }}
      >
        <FiLogOut size={18} />
        Logout
      </button>

      <ConfirmationATM
        show={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={handleLogout}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        buttonText="Logout"
      />
    </>
  );
};

export default LogoutButton;
